class Device {
  constructor() {
    this.numpad = true
  }
  _init = async () => {
    return true
  }

  properties = async () => {
    const properties = {
      mac: webapis.network.getMac(),
      ip: webapis.network.getIp(),
      serial: webapis.systemcontrol.getSerialNumber() || "serial",
      firmware: webapis.productinfo.getFirmware(),
      software: webapis.productinfo.getVersion(),
      manufacturer: "Samsung",
      product: webapis.productinfo.getModel(),
      type: "tizenv2"
    }

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    return res && properties
  }
  baseUrl = async () => {
    return window.selfFrame.src
  }
  getKeyMap = async () => {
    return [
      // Controllers
      [37, "left"],
      [38, "up"],
      [39, "right"],
      [40, "down"],
      [13, "enter"],
      [10009, "back"],
      [10182, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [415, "play"],
      [19, "pause"],
      [10252, "toggle"],
      [413, "stop"],
      [412, "fw"],
      [417, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      [427, "ch_up"],
      [428, "ch_down"],
      [10153, "tv"],
      [10221, "subtitle"],
      [10073, "list"],
      [458, "epg"],

      // General
      [457, "info"],
      [10133, "settings"],
      [10418, "alarm-clock"],
      [-1, "sleep-timer"],
      [10072, "source"],
      [-1, "power"],
      [10071, "home"],
      [10497, "home"],
      [-1, "refresh"],
      [10148, "numerator"],

      [403, "red"],
      [404, "green"],
      [405, "yellow"],
      [406, "blue"],

      // Numpad
      [48, "numpad", 0],
      [49, "numpad", 1],
      [50, "numpad", 2],
      [51, "numpad", 3],
      [52, "numpad", 4],
      [53, "numpad", 5],
      [54, "numpad", 6],
      [55, "numpad", 7],
      [56, "numpad", 8],
      [57, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [10234, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [-1, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"]
    ]
  }
  setName = async name => {
    if (!name) return false
    webapis.network.setTVName(name)
    return true
  }
  getName = async () => {
    return webapis.network.getTVName()
  }

  /* Register Methods */
  registerKeys = async () => {
    const unnecessaryKeys = ["VolumeUp", "VolumeDown", "VolumeMute", "Power"]
    const supportedKeys = tizen.tvinputdevice.getSupportedKeys()
    const supportedKeysSpecial = webapis.appcommon.getSpecialSupportedKeys()

    supportedKeys.forEach(key => {
      tizen.tvinputdevice.unregisterKey([key.name])
      if (unnecessaryKeys.indexOf(key.name) === -1) tizen.tvinputdevice.registerKey([key.name])
    })

    supportedKeysSpecial.forEach(key => {
      webapis.appcommon.unregisterKey([key.name])
      if (unnecessaryKeys.indexOf(key.name) === -1) webapis.appcommon.registerKey([key.name])
    })

    return true
  }

  /* Volume Management */
  volume = async volume => {
    try {
      if (typeof volume !== "number") return tizen.tvaudiocontrol.getVolume()
      tizen.tvaudiocontrol.setVolume(volume)
      return true
    } catch (error) {
      _$.error(error.message)
      return false
    }
  }
  mute = async value => {
    if (["boolean", "number"].indexOf(typeof value) >= 0) {
      tizen.tvaudiocontrol.setMute(value ? true : false)
      return true
    }
    return tizen.tvaudiocontrol.isMute()
  }
  maxVolume = async () => {
    const volumeListener = volume => {
      if (volume > __.device.maxVolume) this.volume(__.device.maxVolume)
      return true
    }
    tizen.tvaudiocontrol.setVolumeChangeListener(volumeListener)
  }

  /* Power Management */
  getPowerState = async () => {
    try {
      return webapis.remotepower.getPowerState() === "NORMAL" ? "on" : "standby"
    } catch (error) {
      throw error.message
    }
  }
  powerOn = async () => {
    /* Library Code */
    webapis.remotepower.powerOn()
    /* Library Code */

    return true
  }
  standBy = async () => {
    /* Library Code */
    webapis.remotepower.powerOff()
    /* Library Code */

    return true
  }
  reboot = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    webapis.systemcontrol.rebootDevice(
      () => promise.resolve(),
      payload => promise.reject(payload.message)
    )
    /* Library Code */

    return promise.done
  }
  clearData = async () => {
    return webapis.systemcontrol.deleteAppPrivateInfo("ON")
  }

  /* Soft AP */
  async getSoftAP() {
    try {
      return {
        ssid: webapis.network.getSoftAPSSID(),
        password: webapis.network.getSoftAPSecurityKey(),
        status: await this.isSoftAPEnabled()
      }
    } catch (err) {
      return {
        ssid: webapis.network.getSoftAPSSID(),
        password: null,
        status: false
      }
    }
  }
  async enableSoftAP() {
    try {
      return webapis.network.enableSoftAP()
    } catch (err) {
      return _$.error(err?.message || err)
    }
  }
  async disableSoftAP() {
    try {
      return webapis.network.disableSoftAP()
    } catch (err) {
      return _$.error(err?.message || err)
    }
  }
  async isSoftAPEnabled() {
    try {
      return webapis.network.isSoftAPEnabled()
    } catch (err) {
      return _$.error(err?.message || err)
    }
  }
}

export default Device
